import {
  screenNameConstants,
  viewPathConstants,
  roles,
  CenterStatusEnum,
} from "../../../constants";
import home from "../../../assets/images/icon/home.svg";
import CompetitionIcon from "../../../assets/images/icon/competition.svg";
import DaimondIcon from "../../../assets/images/icon/diamond.svg";
import LeaderboardIcon from "../../../assets/images/icon/leaderboard.svg";
import UserProfileIcon from "../../../assets/images/icon/user.svg";
import courses_icon from "../../../assets/images/icon/courses_icon.svg";
import subscription_settings_icon from "../../../assets/images/icon/subscription_settings_icon.svg";
import spots_icon from "../../../assets/images/icon/spots_icon.svg";
import refund_policy from "../../../assets/images/icon/refund-policy.svg";
import grad_student from "../../../assets/images/icon/grad_student.png";
import centers from "../../../assets/images/icon/centers.svg";
import instructorsIcon from "../../../assets/images/icon/instructors_black_icon.svg";
import admin_courses_icon from "../../../assets/images/icon/admin_courses_icon.svg";
import payment_history from "../../../assets/images/icon/payment_history.svg";
import audit_logs from "../../../assets/images/icon/audit_logs.svg";
import boatClasses from "../../../assets/images/icon/BoatClasses.svg";

export const getGeneralUserNavLinks = () => {
  return [
    {
      path: `/dashboard`,
      name: screenNameConstants.DASHBOARD,
      iconPath: home,
    },
    {
      path: `/profile`,
      name: screenNameConstants.PROFILE,
      iconPath: UserProfileIcon,
    },
    {
      path: `/my-events`,
      name: screenNameConstants.My_EVENTS,
      iconPath: DaimondIcon,
    },
  ];
};
export const getSuperAdminNavLinks = () => {
  return [
    {
      path: `/instructors`,
      name: screenNameConstants.INSTRUCTORS,
      iconPath: instructorsIcon,
    },
    {
      path: `/users`,
      name: screenNameConstants.USERS,
      iconPath: UserProfileIcon,
    },
    {
      path: `/centers`,
      name: screenNameConstants.CENTERS,
      iconPath: centers,
    },
    {
      path: `/admin/courses`,
      name: screenNameConstants.COURSES,
      iconPath: admin_courses_icon,
    },
    {
      path: `/events`,
      name: screenNameConstants.EVENTS,
      iconPath: DaimondIcon,
    },
    {
      path: `/competitions`,
      name: screenNameConstants.COMPETITIONS,
      iconPath: CompetitionIcon,
    },
    {
      path: `/spots`,
      name: screenNameConstants.SPOTS,
      iconPath: spots_icon,
    },
    {
      path: viewPathConstants.SUBSCRIPTION_SETTINGS,
      name: screenNameConstants.SUBSCRIPTION_SETTINGS,
      iconPath: subscription_settings_icon,
    },
    {
      path: `/admin-users`,
      name: screenNameConstants.ADMIN_USERS,
      iconPath: UserProfileIcon,
    },
    {
      path: viewPathConstants.REFUND_POLICY,
      name: screenNameConstants.REFUND_POLICY,
      iconPath: refund_policy,
    },
    // {
    //   path: viewPathConstants.ADMIN_AUDIT_LOGS,
    //   name: screenNameConstants.ADMIN_AUDIT_LOGS,
    //   iconPath: audit_logs,
    // },
    {
      path: viewPathConstants.ADMIN_PAYMENT_HISTORY,
      name: screenNameConstants.ADMIN_PAYMENT_HISTORY,
      iconPath: payment_history,
    },
    {
      path: viewPathConstants.BOAT_CLASSES,
      name: screenNameConstants.BOAT_CLASSES,
      iconPath: boatClasses,
    },
  ];
};

export const GetInstructorNavLinks = (userData) => {
  // Define the tab conditionally based on user data

  const instructorAllowedCoursesTab =
    userData.user.role === roles.FreelanceInstructor ||
    (userData.user.role === roles.Instructor &&
      userData.instructorCenterId !== null)
      ? {
          path: `/students`,
          name: screenNameConstants.STUDENTS,
          iconPath: grad_student,
        }
      : null;

  // Include the tab if it's allowed
  const links = [
    {
      path: `/profile`,
      name: screenNameConstants.PROFILE,
      iconPath: UserProfileIcon,
    },
    instructorAllowedCoursesTab, // Include the tab conditionally
  ];

  // Filter out null values (if the tab is not allowed)
  return links.filter((link) => link);
};

export const getAdminNavLinks = () => {
  return [
    {
      path: `/instructors`,
      name: screenNameConstants.INSTRUCTORS,
      iconPath: instructorsIcon,
    },
    {
      path: `/users`,
      name: screenNameConstants.USERS,
      iconPath: UserProfileIcon,
    },
    {
      path: `/centers`,
      name: screenNameConstants.CENTERS,
      iconPath: centers,
    },
    {
      path: `/admin/courses`,
      name: screenNameConstants.COURSES,
      iconPath: admin_courses_icon,
    },
    {
      path: `/events`,
      name: screenNameConstants.EVENTS,
      iconPath: DaimondIcon,
    },
    {
      path: `/competitions`,
      name: screenNameConstants.COMPETITIONS,
      iconPath: CompetitionIcon,
    },
    {
      path: `/spots`,
      name: screenNameConstants.SPOTS,
      iconPath: spots_icon,
    },
    {
      path: viewPathConstants.SUBSCRIPTION_SETTINGS,
      name: screenNameConstants.SUBSCRIPTION_SETTINGS,
      iconPath: subscription_settings_icon,
    },
    {
      path: viewPathConstants.REFUND_POLICY,
      name: screenNameConstants.REFUND_POLICY,
      iconPath: refund_policy,
    },
    // {
    //   path: viewPathConstants.ADMIN_AUDIT_LOGS,
    //   name: screenNameConstants.ADMIN_AUDIT_LOGS,
    //   iconPath: audit_logs,
    // },
    {
      path: viewPathConstants.ADMIN_PAYMENT_HISTORY,
      name: screenNameConstants.ADMIN_PAYMENT_HISTORY,
      iconPath: payment_history,
    },
    {
      path: viewPathConstants.BOAT_CLASSES,
      name: screenNameConstants.BOAT_CLASSES,
      iconPath: boatClasses,
    },
  ];
};

export const getCenterNavLinks = (userData) => {
  const defaultNavLinks = [
    {
      path: `/center-profile`,
      name: screenNameConstants.PROFILE,
      iconPath: UserProfileIcon,
    },
  ];

  if (
    userData.centerStatus === CenterStatusEnum.Approved ||
    userData.centerStatus === CenterStatusEnum.PaymentRejected ||
    userData.centerStatus === CenterStatusEnum.Restricted
  ) {
    defaultNavLinks.push(
      {
        path: `/center-instructors`,
        name: screenNameConstants.INSTRUCTORS,
        iconPath: instructorsIcon,
      },
      {
        path: `/center/students`,
        name: screenNameConstants.MY_STUDENTS,
        iconPath: grad_student,
      },
      {
        path: `/center-activity`,
        name: screenNameConstants.CENTER_ACTIVITY,
        iconPath: LeaderboardIcon,
      }
    );
  }
  return defaultNavLinks;
};

export const publicUserTopNavLinks = () => {
  return [
    {
      path: `/view-centers`,
      name: screenNameConstants.CENTERS,
    },
    {
      path: viewPathConstants.VIEW_ALL_SPOTS,
      name: screenNameConstants.SPOTS,
    },
    {
      path: `/view-events`,
      name: screenNameConstants.EVENTS,
    },
    {
      path: viewPathConstants.PUBLIC_COMPETITIONS,
      name: screenNameConstants.COMPETITIONS,
    },
    {
      path: `/leaderboard`,
      name: screenNameConstants.LEADERBOARD,
    },
    {
      path: `/calendar`,
      name: screenNameConstants.CALENDAR,
    },
  ];
};

export const adminTopNavLinks = () => {
  return [
    {
      path: `/leaderboard`,
      name: screenNameConstants.LEADERBOARD,
    },
    {
      path: `/calendar`,
      name: screenNameConstants.CALENDAR,
    },
    {
      path: viewPathConstants.VIEW_ALL_SPOTS,
      name: screenNameConstants.SPOTS,
    },
  ];
};

export const getPractitionerUserNavLinks = () => {
  return [
    {
      path: `/dashboard`,
      name: screenNameConstants.DASHBOARD,
      iconPath: home,
    },
    {
      path: `/profile`,
      name: screenNameConstants.PROFILE,
      iconPath: UserProfileIcon,
    },
    {
      path: `/my-events`,
      name: screenNameConstants.My_EVENTS,
      iconPath: DaimondIcon,
    },
    {
      path: `/courses`,
      name: screenNameConstants.MY_COURSES,
      iconPath: courses_icon,
    },
    {
      path: viewPathConstants.My_COMPETITIONS,
      name: screenNameConstants.MY_COMPETITIONS,
      iconPath: CompetitionIcon,
    },
  ];
};
